@if (googleMapsApiLoaded$ | async) {
  @if (locations$ | async; as locations) {
    <div class="h-layout" *transloco="let t" [attr.id]="sectionId()">
      <div class="px-md md:px-8 lg:px-16">
        @if (title()) {
          <p role="heading" aria-level="2" class="mb-md text-center heading-xl sm:text-left">{{ title() }}</p>
        }

        <google-map
          mapId="pro-map"
          (mapInitialized)="setBounds(locations)"
          [zoom]="3"
          width="100%"
          class="block h-[500px] max-h-[70vh] overflow-hidden rounded-2xl"
        >
          @if (locations.length) {
            <map-marker-clusterer [imagePath]="markerClustererImagePath">
              @for (location of locations; track location.id; let index = $index) {
                <map-marker
                  (mapClick)="showInfoWindow($event, index)"
                  [position]="location.geoPoint!"
                  #marker
                ></map-marker>
                <map-info-window>
                  <div class="space-y-md">
                    @if (location.logo && location.logo.url) {
                      <img [ngSrc]="location.logo.url" class="h-auto w-full max-w-[120px]!" alt="" />
                    }

                    <div>
                      <p>{{ location.companyName }}</p>
                      <p>{{ location.postalCode }} {{ location.locality }}</p>
                    </div>
                    <a [routerLink]="proProfileRoute(location.proSlug)" class="btn btn-secondary">
                      {{ t('proMap.profileButton') }}
                    </a>
                  </div>
                </map-info-window>
              }
            </map-marker-clusterer>
          }
        </google-map>
      </div>
    </div>
  }
}
